import React, { FC } from 'react';
import { graphql } from 'gatsby';
import ImageWithFallback from '../ImageWithFallback';

import {
  StyledSection,
  StyledContentBlock,
  MainContainer,
  MainContentWrapper,
  Title,
  Text,
  CardContainerDesktop,
  ContentContainerDesktop,
  ContentWrapper,
  CardImageWrapper,
  CardTitle,
  CardText,
  CardContainerTablet,
  CardWrapperTablet,
  ContentContainerTabletFirstRow,
  ContentContainerTabletSecondRow,
  CardContainerMobile,
  ContentContainerMobile,
  ContentWrapperMobile,
} from './styled';


const WhyHome: FC<Queries.SeoWhyHomeFragment> = ({
  whyHome,
}) => {
  const { title, subtitle, steps } = whyHome || {};

  return (
    <StyledSection>
      <StyledContentBlock>
        <MainContainer>
          <MainContentWrapper>
            <Title>{title}</Title>
            <Text>{subtitle}</Text>
          </MainContentWrapper>
          {steps && (
            <CardContainerDesktop>
              {steps.map(step => (
                <ContentContainerDesktop key={step?.title}>
                  <ContentWrapper>
                    <CardImageWrapper>
                      <ImageWithFallback
                        src={step?.image}
                        alt={step?.title}
                      />
                    </CardImageWrapper>
                    <CardTitle>{step?.title}</CardTitle>
                    <CardText>{step?.description}</CardText>
                  </ContentWrapper>
                </ContentContainerDesktop>
              ))}
            </CardContainerDesktop>
          )}
          {steps && (
            <CardContainerTablet>
              <CardWrapperTablet>
                {steps.slice(0, 3).map(step => (
                  <ContentContainerTabletFirstRow key={step?.title}>
                    <ContentWrapper>
                      <CardImageWrapper>
                        <ImageWithFallback
                          src={step?.image}
                          alt={step?.title}
                        />
                      </CardImageWrapper>
                      <CardTitle>{step?.title}</CardTitle>
                      <CardText>{step?.description}</CardText>
                    </ContentWrapper>
                  </ContentContainerTabletFirstRow>
                ))}
              </CardWrapperTablet>
              <CardWrapperTablet>
                {steps.slice(3, 5).map(step => (
                  <ContentContainerTabletSecondRow key={step?.title}>
                    <ContentWrapper>
                      <CardImageWrapper>
                        <ImageWithFallback
                          src={step?.image}
                          alt={step?.title}
                        />
                      </CardImageWrapper>
                      <CardTitle>{step?.title}</CardTitle>
                      <CardText>{step?.description}</CardText>
                    </ContentWrapper>
                  </ContentContainerTabletSecondRow>
                ))}
              </CardWrapperTablet>
            </CardContainerTablet>
          )}
          {steps && (
            <CardContainerMobile>
              {steps.map(step => (
                <ContentContainerMobile key={step?.title}>
                  <ContentWrapper>
                    <ContentWrapperMobile>
                      <CardImageWrapper>
                        <ImageWithFallback
                          src={step?.image}
                          alt={step?.title}
                        />
                      </CardImageWrapper>
                      <CardTitle>{step?.title}</CardTitle>
                    </ContentWrapperMobile>
                    <CardText>{step?.description}</CardText>
                  </ContentWrapper>
                </ContentContainerMobile>
              ))}
            </CardContainerMobile>
          )}
        </MainContainer>
      </StyledContentBlock>
    </StyledSection>
  );
};

export const query = graphql`
  fragment SeoWhyHome on Json {
    whyHome {
      title
      subtitle
      steps {
        title
        description
        image
      }
    }
  }
`;

export default WhyHome;
